// removed by extract-text-webpack-plugin
module.exports = {"hidden":"COIrj","visuallyhidden":"RwJa0","hide-text":"_1Lx5f","center":"HxjQM","noprint":"GPZ7P","widgets":"_2-AlQ"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/cn-skin-vg/styles/components/MastheadExtensionWidgets.scss
 ** module id = 453
 ** module chunks = 0
 **/